import React from 'react'
import C from '../Const'
import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceArea,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from '../recharts'
import U from '../Utils'

function ChartAssunzPerAnno(props) {
  const { series, data, filters, print } = props
  const { assunz_per_anno, year_bounds } = data

  const { first_year, last_full_year, last_year } = year_bounds
  const from = filters.from || last_year
  const to = filters.to || last_year

  const colors = series.length > 1 ? [C.BLUE, C.RED] : [C.YELLOW]

  return (
    <ResponsiveContainer aspect={C.ASPECT} className="ChartAssunzPerAnno">
      <LineChart data={assunz_per_anno}>
        <ReferenceArea x1={first_year} x2={Math.min(last_full_year, from - 0.5)} fill={C.AREA_BG} />
        <ReferenceArea x1={to + 0.5} x2={last_full_year} fill={C.AREA_BG} />
        <CartesianGrid strokeDasharray="5 5" />
        <XAxis type="number" domain={[first_year, last_full_year]} dataKey="year" />
        <YAxis type="number" tickFormatter={U.formatNumber} />
        <Tooltip formatter={U.formatNumber} />
        {series.map((ser, s) => (
          <Line
            key={s}
            dataKey={'val' + ser.suf}
            stroke={colors[s]}
            strokeWidth={3}
            name={'Assunzioni ' + ser.name}
            isAnimationActive={!print}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  )
}

export default ChartAssunzPerAnno



// WEBPACK FOOTER //
// ./src/main/ChartAssunzPerAnno.js